function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.73828 9.01562C8.57422 9.17969 8.27344 9.17969 8.10938 9.01562L4.5 5.37891L0.863283 9.01562C0.699221 9.17969 0.398439 9.17969 0.234377 9.01562C0.0703144 8.85156 0.0703143 8.55078 0.234377 8.38672L3.87109 4.75L0.234376 1.14062C0.070313 0.976562 0.070313 0.675781 0.234375 0.511718C0.398438 0.347656 0.699219 0.347656 0.863282 0.511718L4.5 4.14844L8.10938 0.511717C8.27344 0.347654 8.57422 0.347654 8.73828 0.511717C8.90234 0.675779 8.90234 0.976561 8.73828 1.14062L5.10156 4.75L8.73828 8.38672C8.90235 8.55078 8.90235 8.85156 8.73828 9.01562Z",
  fill: "currentColor"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.086f79a7.svg";
export { ForwardRef as ReactComponent };